import { createSlice } from '@reduxjs/toolkit';
import { loadAgents } from './agents.middleware';
import { logout } from '../auth/auth-middleware';

export type AgentOption = {
    label: string;
    value: string;
};

type State = {
    list: AgentOption[];
    error: string | null;
    isLoading: boolean;
    isLoaded: boolean;
};

const initialState: State = {
    list: [],
    error: null,
    isLoading: false,
    isLoaded: false,
};

export const agentsSlice = createSlice({
    name: 'app/agents',
    initialState,
    reducers: {
        clearAgents: (state) => {
            state.list = [];
            state.error = null;
            state.isLoaded = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadAgents.fulfilled, (state, action) => {
                state.list = action.payload;
                state.error = null;
                state.isLoading = false;
                state.isLoaded = true;
            })
            .addCase(loadAgents.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(loadAgents.rejected, (state, action) => {
                state.error = action.payload as string;
                state.isLoading = false;
            })
            .addCase(logout.fulfilled, (state) => {
                state.list = [];
                state.error = null;
                state.isLoading = false;
                state.isLoaded = false;
            });
    },
});

export const { clearAgents } = agentsSlice.actions;
export default agentsSlice.reducer;
